import { z } from 'zod'
import { createValidator } from '@mc/form-utils'
import { i18nInstance } from './i18n/i18nInstance'

const tf = i18nInstance.getFixedT(null, '@mc/authentication')

// ============================================
// Reusable Field Schemas
// ============================================

export const emailSchema = z
  .string({ required_error: tf('loginForm.email.presence') })
  .min(1, tf('loginForm.email.presence'))
  .email(tf('loginForm.email.valid'))

export const passwordSchema = z
  .string({ required_error: tf('loginForm.password.presence') })
  .min(1, tf('loginForm.password.presence'))

export const passwordWithMinLengthSchema = z
  .string({ required_error: tf('loginForm.password.presence') })
  .min(1, tf('loginForm.password.presence'))
  .min(4, tf('registerForm.password.tooShort'))

export const passwordConfirmationSchema = z
  .string({ required_error: tf('confirmPasswordForm.password.presence') })
  .min(1, tf('confirmPasswordForm.password.presence'))

// ============================================
// Form Schemas
// ============================================

export const loginSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
})

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordWithMinLengthSchema,
})

export const resetPasswordSchema = z.object({
  email: emailSchema,
})

export const confirmPasswordSchema = z.object({
  password_confirmation: passwordConfirmationSchema,
})

// ============================================
// Pre-built Validators
// ============================================

export const validateLogin = createValidator(loginSchema)
export const validateRegister = createValidator(registerSchema)
export const validateResetPassword = createValidator(resetPasswordSchema)
export const validateConfirmPassword = createValidator(confirmPasswordSchema)
